export type SignupEmailDomainClassification =
  | {
      kind: "personal";
      domain: string;
    }
  | {
      kind: "company";
      domain: string;
    }
  | {
      kind: "unknown";
      domain: null;
    };

const PERSONAL_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "yahoo.com",
  "ymail.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "gmx.com",
  "mail.com",
]);

function normalizeEmailDomain(email: string): string | null {
  const [, domain] = email.trim().toLowerCase().split("@");
  return domain && domain.includes(".") ? domain : null;
}

export function isPersonalEmailDomain(domain: string): boolean {
  return PERSONAL_EMAIL_DOMAINS.has(domain.trim().toLowerCase());
}

export function classifySignupEmailDomain(
  email: string,
): SignupEmailDomainClassification {
  const domain = normalizeEmailDomain(email);

  if (!domain) {
    return {
      kind: "unknown",
      domain: null,
    };
  }

  if (isPersonalEmailDomain(domain)) {
    return {
      kind: "personal",
      domain,
    };
  }

  return {
    kind: "company",
    domain,
  };
}
